<div *ngFor="let request of data; let i = index" class="request-card mb-3">
  <div class="request-card__header">
    <div class="request-card__title">
      <span class="request-card__name">{{ request.companyName }}</span>
      <small class="request-card__date text-muted">{{ request.creationDate | date:'dd MMM yyyy' }}</small>
    </div>
    <span class="badge" [ngClass]="{
      'badge-warning': !request.processed && !request.rejected,
      'badge-success': request.processed && !request.rejected,
      'badge-danger': request.processed && request.rejected
    }">
      <span *ngIf="!request.processed && !request.rejected" translate>STATUS_PENDING</span>
      <span *ngIf="request.processed && !request.rejected" translate>STATUS_ACCEPTED</span>
      <span *ngIf="request.processed && request.rejected" translate>STATUS_REJECTED</span>
    </span>
  </div>

  <div class="request-card__body">
    <div class="request-card__accordion px-3 py-2">
      <div class="request-section request-section--from-customer">
        <div class="request-section-label" translate>REQUEST_FROM_CUSTOMER</div>
        <lib-gung-accordion>
          <lib-gung-accordion-item [id]="'address-' + i" [collapsed]="true">
            <ng-template libGungAccordionHeader>{{ 'ADDRESS' | translate }}</ng-template>
            <ng-template libGungAccordionBody>
              <div class="request-fields">
                <div class="request-field">
                  <span class="request-label" translate>ORG_NUMBER</span>
                  <span class="request-value">{{ request.companyOrganisationId }}</span>
                </div>
                <div class="request-field">
                  <span class="request-label" translate>CITY</span>
                  <span class="request-value">{{ request.deliveryCity }}</span>
                </div>
                <div class="request-field">
                  <span class="request-label" translate>COUNTRY</span>
                  <span class="request-value">{{ request.deliveryCountry }}</span>
                </div>
              </div>
            </ng-template>
          </lib-gung-accordion-item>

          <lib-gung-accordion-item [id]="'user-' + i" [collapsed]="true">
            <ng-template libGungAccordionHeader>{{ 'USER' | translate }}</ng-template>
            <ng-template libGungAccordionBody>
              <div class="request-fields">
                <div class="request-field">
                  <span class="request-label" translate>CONTACT_PERSON</span>
                  <span class="request-value">{{ request.contactPerson }}</span>
                </div>
                <div class="request-field">
                  <span class="request-label" translate>PHONE</span>
                  <span class="request-value">{{ request.phone }}</span>
                </div>
                <div class="request-field">
                  <span class="request-label" translate>EMAIL</span>
                  <span class="request-value">{{ request.email }}</span>
                </div>
              </div>
            </ng-template>
          </lib-gung-accordion-item>
        </lib-gung-accordion>
      </div>

      <ng-container *ngIf="request.processed && !request.rejected && showCreatedCustomerData">
        <div class="request-section request-section--created-customer mt-2">
          <div class="request-section-label" translate>CREATED_CUSTOMER</div>
          <lib-gung-accordion>
            <lib-gung-accordion-item [id]="'created-address-' + i" [collapsed]="true">
              <ng-template libGungAccordionHeader>{{ 'ADDRESS' | translate }}</ng-template>
              <ng-template libGungAccordionBody>
                <span class="text-muted" translate>NOT_IMPLEMENTED</span>
              </ng-template>
            </lib-gung-accordion-item>
            <lib-gung-accordion-item [id]="'created-conditions-' + i" [collapsed]="true">
              <ng-template libGungAccordionHeader>{{ 'CONDITIONS' | translate }}</ng-template>
              <ng-template libGungAccordionBody>
                <span class="text-muted" translate>NOT_IMPLEMENTED</span>
              </ng-template>
            </lib-gung-accordion-item>
            <lib-gung-accordion-item [id]="'created-user-' + i" [collapsed]="true">
              <ng-template libGungAccordionHeader>{{ 'USER' | translate }}</ng-template>
              <ng-template libGungAccordionBody>
                <span class="text-muted" translate>NOT_IMPLEMENTED</span>
              </ng-template>
            </lib-gung-accordion-item>
            <lib-gung-accordion-item [id]="'created-admin-' + i" [collapsed]="true">
              <ng-template libGungAccordionHeader>{{ 'ADMIN_DATA' | translate }}</ng-template>
              <ng-template libGungAccordionBody>
                <span class="text-muted" translate>NOT_IMPLEMENTED</span>
              </ng-template>
            </lib-gung-accordion-item>
          </lib-gung-accordion>
        </div>
      </ng-container>
    </div>

    <div class="request-card__actions">
      <ng-container *ngIf="!request.processed || request.rejected">
        <button
          type="button"
          class="btn btn-dark w-100 mb-2"
          (click)="createCustomer(request)"
          [disabled]="request.rejected"
          translate
        >
          CREATE_CUSTOMER
        </button>
        <button
          *ngIf="!request.processed"
          type="button"
          class="btn btn-outline-danger w-100"
          (click)="rejectRequest(request)"
          translate
        >
          REJECT_USER
        </button>
      </ng-container>

      <ng-container *ngIf="request.processed && !request.rejected">
        <button class="btn btn-success w-100 mb-2" disabled translate>CUSTOMER_EXISTS</button>
        <div class="text-muted small">{{ 'PROCESSED_BY' | translate }}: {{ request.processedByUserId }}</div>
      </ng-container>

      <ng-container *ngIf="request.processed && request.rejected">
        <button class="btn btn-danger w-100 mb-2" disabled translate>USER_REJECTED</button>
        <div class="text-muted small mb-2">{{ 'PROCESSED_BY' | translate }}: {{ request.processedByUserId }}</div>
        <button
          type="button"
          class="btn btn-outline-secondary w-100"
          (click)="reactivateRequest(request)"
          translate
        >
          REACTIVATE_REQUEST
        </button>
      </ng-container>

      <div class="request-card__comment">
        <ng-container *ngIf="editingCommentId === request.id; else commentDisplay">
          <textarea
            class="form-control form-control-sm"
            rows="3"
            [(ngModel)]="commentDraft"
            [ngModelOptions]="{ standalone: true }"
            [placeholder]="'COMMENT' | translate"
          ></textarea>
          <div class="request-card__comment-buttons">
            <button
              type="button"
              class="btn btn-sm btn-dark"
              [disabled]="savingComment"
              (click)="saveComment(request)"
            >
              {{ 'SAVE' | translate }}
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              [disabled]="savingComment"
              (click)="cancelEditComment()"
            >
              {{ 'CANCEL' | translate }}
            </button>
          </div>
        </ng-container>

        <ng-template #commentDisplay>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary w-100"
            (click)="startEditComment(request)"
          >
            {{ (request.extra?.comment ? 'EDIT_COMMENT' : 'ADD_COMMENT') | translate }}
          </button>
          <div *ngIf="request.extra?.comment" class="request-card__comment-text">
            {{ request.extra.comment }}
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
